export interface IConf {
    productId: string;
    variantId: string;
    title: string;
    desc: string;
    pc: string;
    h5: string;
}

const conf: Record<string, IConf[]> = {
    eu: [
        {
            productId: '9941778137431',
            variantId: '50238849384791',
            title: 'EcoFlow STREAM Semi-enclosed Balcony Kit (900Wp)',
            desc: '2 × 450W Rigid Solar Panels +  STREAM Microinverter 800W +  2 × Semi-enclosed Balcony Brackets',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231402493/p1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231405370/p1_h5.jpg',
        },
        {
            productId: '9944397480279',
            variantId: '50244823843159',
            title: 'EcoFlow STREAM Facade Kit (900Wp)',
            desc: '2 × 450W Rigid Solar Panels + STREAM Microinverter 800W + 2 × Bracket - Facade',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750748071574/p2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750748076371/p2_h5.jpg',
        },
        {
            productId: '9944391057751',
            variantId: '50244722753879',
            title: 'EcoFlow STREAM Garden Kit (900Wp)',
            desc: '2 × 450W Rigid Solar Panels +  STREAM Microinverter 800W  +  2 × Garden Brackets',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231460695/p3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231463928/p3_h5.jpg',
        },
        {
            productId: '9944391876951',
            variantId: '50244796023127',
            title: 'EcoFlow STREAM Pitched Roof Kit (900Wp)',
            desc: '2 × 450W Rigid Solar Panels + STREAM Microinverter 800W  +  2 × Pitched Roof Brackets',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231495684/p4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231498752/p4_h5.jpg',
        },
        {
            productId: '9944391057751',
            variantId: '50244722786647',
            title: 'EcoFlow STREAM Ground Kit (900Wp)',
            desc: '2 × 450W Rigid Solar Panels +  STREAM Microinverter 800W + 2 × Ground Adjustable Brackets',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231523533/p5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231526758/p5_h5.jpg',
        },
    ],
    uk: [
        {
            productId: '9824771146067',
            variantId: '50632830419283',
            title: 'EcoFlow STREAM Semi-enclosed Balcony Kit (900Wp)',
            desc: '2 × 450W Rigid Solar Panels +  STREAM Microinverter 800W +  2 × Semi-enclosed Balcony Brackets',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231402493/p1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231405370/p1_h5.jpg',
        },
        {
            productId: '9824771408211',
            variantId: '50632831140179',
            title: 'EcoFlow STREAM Facade Kit (900Wp)',
            desc: '2 × 450W Rigid Solar Panels + STREAM Microinverter 800W + 2 × Bracket - Facade',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750748071574/p2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750748076371/p2_h5.jpg',
        },
        {
            productId: '9824771178835',
            variantId: '50632830583123',
            title: 'EcoFlow STREAM Garden Kit (900Wp)',
            desc: '2 × 450W Rigid Solar Panels +  STREAM Microinverter 800W  +  2 × Garden Brackets',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231460695/p3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231463928/p3_h5.jpg',
        },
        {
            productId: '9824771277139',
            variantId: '50632830812499',
            title: 'EcoFlow STREAM Pitched Roof Kit (900Wp)',
            desc: '2 × 450W Rigid Solar Panels + STREAM Microinverter 800W  +  2 × Pitched Roof Brackets',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231495684/p4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231498752/p4_h5.jpg',
        },
        {
            productId: '9824771178835',
            variantId: '50632830615891',
            title: 'EcoFlow STREAM Ground Kit (900Wp)',
            desc: '2 × 450W Rigid Solar Panels +  STREAM Microinverter 800W + 2 × Ground Adjustable Brackets',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231523533/p5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231526758/p5_h5.jpg',
        },
    ],
    de: [
        {
            productId: '15094825582973',
            variantId: '55582152262013',
            title: 'EcoFlow STREAM Loggia Kit (900 Wp)',
            desc: '2 × 450 W Starres Solarpanel + STREAM Mikro-Wechselrichter 800W + 2 × Loggia-Halterung',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231402493/p1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231405370/p1_h5.jpg',
        },
        {
            productId: '15094825681277',
            variantId: '55582152819069',
            title: 'EcoFlow STREAM Fassaden Kit (900 Wp)',
            desc: '2 × 450 W Starres Solarpanel + STREAM Mikro-Wechselrichter 800W + 2 × Halterung - Fassade',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750748071574/p2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750748076371/p2_h5.jpg',
        },
        {
            productId: '15094825615741',
            variantId: '55582152425853',
            title: 'EcoFlow STREAM Garten Kit (900 Wp)',
            desc: '2 × 450 W Starres Solarpanel + STREAM Mikro-Wechselrichter 800W + 2 × Gartenhalterung',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231460695/p3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231463928/p3_h5.jpg',
        },
        {
            productId: '15094825648509',
            variantId: '55582152589693',
            title: 'EcoFlow STREAM Schrägdach Kit (900 Wp)',
            desc: '2 × 450 W Starres Solarpanel + STREAM Mikro-Wechselrichter 800W + 2 × Schrägdachhalterung',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231495684/p4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231498752/p4_h5.jpg',
        },
        {
            productId: '15094825615741',
            variantId: '55582152458621',
            title: 'EcoFlow STREAM Boden Kit (900 Wp)',
            desc: '2 × 450 W Starres Solarpanel + STREAM Mikro-Wechselrichter 800W + 2 × Verstellbare Bodenhalterung',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231523533/p5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231526758/p5_h5.jpg',
        },
    ],
    fr: [
        {
            productId: '9804551422299',
            variantId: '50286347583835',
            title: 'EcoFlow STREAM Kit de balcon semi-fermé (900 Wc)',
            desc: '2 panneaux solaires rigides 450 W + micro-onduleur STREAM 800 W + 2 supports de balcon semi-fermé',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231402493/p1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231405370/p1_h5.jpg',
        },
        {
            productId: '9804551520603',
            variantId: '50286348140891',
            title: 'Kit de façade EcoFlow STREAM (900 Wc)',
            desc: '2 panneaux solaires rigides 450 W + micro-onduleur STREAM 800 W + 2 support – Façade',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750748071574/p2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750748076371/p2_h5.jpg',
        },
        {
            productId: '9804551455067',
            variantId: '50286347747675',
            title: 'Kit de jardin EcoFlow STREAM (900 Wc)',
            desc: '2 panneaux solaires rigides 450 W + micro-onduleur STREAM 800 W + 2 supports de jardin',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231460695/p3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231463928/p3_h5.jpg',
        },
        {
            productId: '9804551487835',
            variantId: '50286347911515',
            title: 'Kit de toit incliné EcoFlow STREAM (900 Wc)',
            desc: '2 panneaux solaires rigides 450 W + micro-onduleur STREAM 800 W + 2 supports de toit incliné',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231495684/p4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231498752/p4_h5.jpg',
        },
        {
            productId: '9804551455067',
            variantId: '50286347780443',
            title: 'Kit de montage au sol EcoFlow STREAM (900 Wc)',
            desc: '2 panneaux solaires rigides 450 W + micro-onduleur STREAM 800 W + 2 supports de montage au sol réglables',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231523533/p5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231526758/p5_h5.jpg',
        },
    ],
    it: [
        {
            productId: '14897221697912',
            variantId: '54987798151544',
            title: 'Kit per balcone semi-chiuso EcoFlow STREAM (900 Wp)',
            desc: '2 pannelli solari rigidi da 450 W + Microinverter STREAM da 600 W + 2 staffe per balcone semi-chiuso',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231402493/p1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231405370/p1_h5.jpg',
        },
        {
            productId: '14897221796216',
            variantId: '54987798708600',
            title: 'Kit per facciata EcoFlow STREAM (900 Wp)',
            desc: '2 pannelli solari rigidi da 450 W + Microinverter STREAM da 600 W + 2 supporto – Facciata',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750748071574/p2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750748076371/p2_h5.jpg',
        },
        {
            productId: '14897221730680',
            variantId: '54987798315384',
            title: 'Kit di montaggio a terra EcoFlow STREAM (900 Wp)',
            desc: '2 pannelli solari rigidi da 450 W + Microinverter STREAM da 600 W + 2 staffe per giardino',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231460695/p3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231463928/p3_h5.jpg',
        },
        {
            productId: '14897221763448',
            variantId: '54987798479224',
            title: 'Kit per tetti inclinati EcoFlow STREAM (900 Wp)',
            desc: '2 pannelli solari rigidi da 450 W + Microinverter STREAM da 600 W + 2 staffe per tetto inclinato',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231495684/p4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231498752/p4_h5.jpg',
        },
        {
            productId: '14897221730680',
            variantId: '54987798348152',
            title: 'Kit di montaggio a terra EcoFlow STREAM (900 Wp)',
            desc: '2 pannelli solari rigidi da 450 W + Microinverter STREAM da 600 W + 2 staffe regolabili per montaggio a terra',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231523533/p5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231526758/p5_h5.jpg',
        },
    ],
    es: [
        {
            productId: '9804554469723',
            variantId: '50286360789339',
            title: 'Kit para balcón semicerrado EcoFlow STREAM (900 Wp)',
            desc: ' 2 paneles solares rígidos de 450 W + inversor STREAM de 800 W + 2 soportes para balcones semicerrados',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231402493/p1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231405370/p1_h5.jpg',
        },
        {
            productId: '9804554568027',
            variantId: '50286361346395',
            title: 'Kit para fachada EcoFlow STREAM (900 Wp)',
            desc: '2 paneles solares rígidos de 450 W + inversor STREAM de 800 W + 2 soporte - Fachada',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750748071574/p2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750748076371/p2_h5.jpg',
        },
        {
            productId: '9804554502491',
            variantId: '50286360953179',
            title: 'Kit para jardín EcoFlow STREAM (900 Wp)',
            desc: '2 paneles solares rígidos de 450 W + inversor STREAM de 800 W + 2 soportes para jardín',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231460695/p3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231463928/p3_h5.jpg',
        },
        {
            productId: '9804554535259',
            variantId: '50286361117019',
            title: 'Kit para techos inclinados EcoFlow STREAM (900 Wp)',
            desc: '2 paneles solares rígidos de 450 W + inversor STREAM de 800 W + 2 soportes para techos inclinados',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231495684/p4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231498752/p4_h5.jpg',
        },
        {
            productId: '9804554502491',
            variantId: '50286360985947',
            title: 'Kit para suelo EcoFlow STREAM (900 Wp)',
            desc: '2 paneles solares rígidos de 450 W + inversor STREAM de 800 W + 2 soportes ajustables para suelo',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743231523533/p5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743231526758/p5_h5.jpg',
        },
    ],
};

export default conf;
